// extracted by mini-css-extract-plugin
module.exports = {"root":"Container-module__root___J+BCK","root--full-width":"Container-module__root--full-width___GaftF"};